import { createSSRApp } from 'vue'
import App from './App.vue'
import pinia from './stores'
import asyncError from './networkErr/index.vue'
import { createI18n } from 'vue-i18n'
import messages from './static/locales/index'
// #ifdef WEB
import Directive from './utils/directive/index'
// #endif
let lang: any = { value: 'en-us' }
try {
  const langStr = localStorage.getItem('commonData')
  if (langStr && JSON.parse(langStr)?.lang) {
    lang = JSON.parse(langStr)?.lang
  }
} catch (error) {
  console.warn('Failed to parse lang from localStorage:', error)
  lang = { value: 'en-us' }
}
console.log('当前语言', lang)
const i18n = createI18n({
  legacy: false,
  locale: lang.value,
  messages,
})

export function createApp() {
  const app = createSSRApp(App)
  app.use(pinia)
  app.use(i18n)
  app.component('asyncError', asyncError) // 全局注册网络异常页面组件（manifest.json中配置）
  // #ifdef WEB
  app.use(Directive)
  // #endif
  return {
    app,
  }
}
